import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './components/LoginPage';
import { DashboardLayout } from './components/DashboardLayout';
import { DashboardPage } from './components/DashboardPage';
import { GeneratorPage } from './components/GeneratorPage';
import { CommunityPage } from './components/CommunityPage';
import { UsersPage } from './components/UsersPage';
import { EmbedPage } from './components/EmbedPage';
import PrivateRoute from './components/PrivateRoute';
import { useUserStore } from './stores/userStore';
import './globals.css';

function App() {
  const clearUser = useUserStore((state) => state.clearUser);

  // Validate token on app load
  useEffect(() => {
    const token = useUserStore.getState().token;

    // Clear invalid tokens
    if (token === 'undefined' || token === 'null' || token === '') {
      console.warn('Invalid token detected, clearing...');
      clearUser();
    }
  }, [clearUser]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/embed/:id" element={<EmbedPage />} />

        <Route element={<PrivateRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/generator" element={<GeneratorPage />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/users" element={<UsersPage />} />
          </Route>
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;